import axios from 'axios';
import store from '@/store';
import router from '@/router';

// Create an axios instance
const service = axios.create({
  baseURL: '/api',
  timeout: 5000,
});

// Request interceptor
service.interceptors.request.use(
  (config) => {
    // Do not send token for login request
    if (store.getters.isLoggedIn && !config.url.includes('/auth/login')) {
      config.headers['Authorization'] = 'Bearer ' + store.state.user.token;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// Response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      // Handle 401 Unauthorized
      if (res.code === 401) {
        store.dispatch('resetToken').then(() => {
          router.replace('/login');
          // You might want to show a message here
          // location.reload();
        });
      }
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res;
    }
  },
  (error) => {
    console.log('err' + error);
    if (error.response && error.response.status === 401) {
      store.dispatch('resetToken').then(() => {
        router.replace('/login');
      });
    }
    return Promise.reject(error);
  }
);

export default service;
